import { buildQuery } from '@calendly/http-tools'

import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getUserConsolidations: build.query({
      query: () => {
        const params = { user_id: 'me' }
        const query = buildQuery(params)

        return { method: 'GET', url: `/api/user_consolidations?${query}` }
      },
    }),
  })
})

export const { useGetUserConsolidationsQuery } = api
